// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/_mini-css-extract-plugin@1.6.2@mini-css-extract-plugin/dist/loader.js!../../node_modules/_css-loader@3.6.0@css-loader/dist/cjs.js!../../node_modules/_less-loader@7.3.0@less-loader/dist/cjs.js??ref--9-4!./default.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = require("!../../node_modules/_style-loader@0.18.2@style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/_mini-css-extract-plugin@1.6.2@mini-css-extract-plugin/dist/loader.js!../../node_modules/_css-loader@3.6.0@css-loader/dist/cjs.js!../../node_modules/_less-loader@7.3.0@less-loader/dist/cjs.js??ref--9-4!./default.less", function() {
			var newContent = require("!!../../node_modules/_mini-css-extract-plugin@1.6.2@mini-css-extract-plugin/dist/loader.js!../../node_modules/_css-loader@3.6.0@css-loader/dist/cjs.js!../../node_modules/_less-loader@7.3.0@less-loader/dist/cjs.js??ref--9-4!./default.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}